import React, { useState, useEffect } from 'react'; 
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from "react-toastify";

function EditLeads({ client, closeModal, onLeadsUpdated }) {
  const navigate = useNavigate();
  const [clientData, setClientData] = useState(client);

  useEffect(() => {
    setClientData(client); // Update when client prop changes
  }, [client]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setClientData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/Leads/${client._id}`, clientData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      toast.success("Client updated successfully!");
        
    // 🔑 Call the function to trigger a refresh
    if (onLeadsUpdated) onLeadsUpdated();
      closeModal();
    } catch (error) {
      console.error('Error updating client:', error);
      toast.error("Failed to update client!");
    }
  };

  return (
    <div className="modal-body max-h-[80vh] overflow-y-auto p-6">
      <h2 className="text-2xl font-semibold mb-4">Edit Lead</h2>
      <form onSubmit={handleUpdate} className="space-y-6">
        {/* Basic Client Info */}
        <div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Lead Type</label>
            <select
              name="leadType"
              value={clientData.leadType}
              onChange={handleChange}
              required
              className="w-full p-2 border border-gray-300 rounded-md"
            >
              <option value="">Select a lead type</option>
              <option value="Cold Leads">Cold Leads - Never interacted with OneHub</option>
              <option value="Warm Leads">Warm Leads - Showed interest but no commitment</option>
              <option value="Hot Leads">Hot Leads - Ready to purchase</option>
              <option value="Referral Leads">Referral Leads - Sent by customers or partners</option>
              <option value="Inbound Leads">Inbound Leads - Found us through content or ads</option>
              <option value="Revival Leads">Revival Leads - Past leads that went cold</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Lead Name</label>
            <input
              type="text"
              name="LeadName"
              value={clientData.LeadsName || ''}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[a-zA-Z\s]*$/.test(value)) {
                  handleChange(e);
                }
              }}
              required
              className="w-full p-2 border border-gray-300 rounded-md"
              placeholder="Enter Lead name"
            />
          </div>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">Company</label>
          <input
            type="text"
            name="company"
            value={clientData.company || ''}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-md"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">Group</label>
          <input
            type="text"
            name="group"
            value={clientData.group || ''}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-md"
          />
        </div>

        {/* Contact Information */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Email</label>
            <input
              type="email"
              name="Email"
              value={clientData.Email || ''}
              onChange={handleChange}
              required
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Contact</label>
            <input
              type="tel"
              name="contact"
              value={clientData.contact || ''}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  handleChange(e);
                }
              }}
              required
              pattern="\d{10}"
              inputMode="numeric"
              maxLength={10}
              className="w-full p-2 border border-gray-300 rounded-md"
              placeholder="Enter 10-digit mobile number"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Alternate Contact</label>
            <input
              type="tel"
              name="contactalt"
              value={clientData.contactalt || ''}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  handleChange(e);
                }
              }}
              required
              pattern="\d{10}"
              inputMode="numeric"
              maxLength={10}
              className="w-full p-2 border border-gray-300 rounded-md"
              placeholder="Enter 10-digit mobile number"
            />
          </div>
        </div>

        {/* Address Information */}
        <div className="bg-gray-100 p-4 rounded-lg border mb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div className="mb-4">
              <label className="block text-sm font-medium mb-2">Building</label>
              <input
                type="text"
                name="building"
                value={clientData.building || ''}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium mb-2">Street</label>
              <input
                type="text"
                name="street"
                value={clientData.street || ''}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div className="mb-4">
              <label className="block text-sm font-medium mb-2">City</label>
              <input
                type="text"
                name="city"
                value={clientData.city || ''}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium mb-2">State</label>
              <input
                type="text"
                name="state"
                value={clientData.state || ''}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">District</label>
            <textarea
              name="district"
              value={clientData.district || ''}
              onChange={handleChange}
              required
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Pincode</label>
            <input
              type="number"
              name="pincode"
              value={clientData.pincode || ''}
              onChange={handleChange}
              required
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-between mt-4">
          <button
            type="submit"
            className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600"
          >
            Save Changes
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditLeads;
